import React from 'react';
import { useTranslation } from 'react-i18next';
import { IMembershipPlan, IMembershipPlanPrice } from '../../types/model';
import { Button } from '../../components/UI';
import { WelcomePack, getPlanClasses } from './Utils';

interface PropTypes {
  membershipPlan: IMembershipPlan;
  renewal: 'MONTHLY' | 'YEARLY';
  onSelect: () => void;
}

const PlanCard: React.FC<PropTypes> = ({
  membershipPlan,
  renewal,
  onSelect,
}) => {
  const { t } = useTranslation();

  const price = membershipPlan.prices.find(
    ({ renewal: priceRenewal }) => priceRenewal === renewal
  ) as IMembershipPlanPrice;
  const renewalShortName =
    renewal === 'MONTHLY'
      ? t('choosePlan.monthShort')
      : t('choosePlan.yearShort');

  const planClasses = getPlanClasses(membershipPlan);

  return (
    <div className="rounded-lg shadow-lg text-left bg-white">
      <div
        className={`px-4 py-2 ${planClasses} text-lg font-semibold rounded-tl-lg rounded-tr-lg`}
      >
        {membershipPlan.title}
      </div>
      <div className="p-4 flex flex-col gap-2">
        <div className="flex justify-between text-black text-sm">
          <div className="text-md">
            <span className="font-semibold">${price.price}</span>/
            {renewalShortName}
          </div>
          {renewal !== 'MONTHLY' && membershipPlan.sku !== 'Camelot' && (
            <WelcomePack />
          )}
        </div>
        <div className="text-grey-70">
          {t(`packages.${membershipPlan.title}`)}
        </div>
        <div className="text-center">
          <Button variant="primary" buttonClass="w-full" onClick={onSelect}>
            {t('choosePlan.choosePlan')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
